import axios from "axios";
import { AuthContext } from "context/AuthContext";
import { useContext, useState } from "react";
import getIP from "../../getIP.js";
import getAPIMap from "api_map.js";
import ErrorModal from "../Modals/ErrorModal";

const IP = getIP();

const AiAgentMenu = ({ className, menuTextColor, children }) => {
    const {
        userDetails,
    } = useContext(AuthContext);
    const [errorModal, setErrorModal] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    const handleRedirect = async () => {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${userDetails?.token}`,
                },
            };
            var url = IP + getAPIMap("generateTempToken");
            const res = await axios.get(url, {}, config);
            if(res?.data?.data) {
                const redirectUrl = res.data.data;
                window.open(redirectUrl);
            }
        } catch (err) {
            const apiMessage = err?.response?.data?.message;
            setErrorMsg(apiMessage || "Sorry! Something went wrong. Please try again");
            setErrorModal(true);
        }

    }
    return (
        <>
            <a
                href={"#"}
                onClick={(e) => {
                    e.preventDefault();
                    handleRedirect();
                }}
                target="_blank"
                rel="noopener noreferrer"
                className={className}
                style={{ color: menuTextColor }}
            >
                {children}
            </a>

            <ErrorModal
                deleteError={errorMsg}
                errorModal={errorModal}
                setErrorModal={setErrorModal}
            />
        </>
    );

}

export default AiAgentMenu;